import { HistoricDpendenciesCellComponent } from './../historic.dependencies.cell.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { CustomEntityUtils } from './../../../custom-entity-utils.service';
import { Console } from 'console';

@Component({
  selector: 'ngx-elements-history',
  templateUrl: './elements-history.component.html',
  styleUrls: ['./elements-history.component.scss']
})
export class ElementsHistoryComponent implements OnInit {

  public reset: any[] = [{}];
  elementAttributesArray = [];
  elementSource: LocalDataSource = new LocalDataSource();
  userRole: [String] = ['manager'];
  initColumns= {
    name: {
      title: 'Nombre',
      type: 'string',
    },
    workingfrom: {
      title: 'Vigente desde',
      type: 'string',
      valuePrepareFunction: (date) => {
        var raw = new Date(date);

        var formatted = this.datePipe.transform(raw, 'dd/MM/yyyy');
        return formatted;
      }
    },
    workinguntil: {
      title: 'Vigente hasta',
      type: 'string',
      valuePrepareFunction: (date) => {
        var raw = new Date(date);

        var formatted = this.datePipe.transform(raw, 'dd/MM/yyyy');
        return formatted;
      }
    }
  }

  settings = {

    noDataMessage:'No hay elementos',
    actions: {
      delete: false,
      add: false,
      edit:false,
      columnTitle:''
  },


    columns: this.initColumns
  };
  currentEntity: any;

  constructor(private userSessionService: UserSessionService,protected customEntityUtils: CustomEntityUtils,private datePipe: DatePipe) { }

  async ngOnInit() {

    this.userRole = this.userSessionService.user.acl_roles;
    this.currentEntity = await this.customEntityUtils.getCurrentEntity()

    this.settings.columns = JSON.parse(JSON.stringify(this.initColumns));

    /*
    this.settings.columns = {
      name: {
        title: 'Nombre',
        type: 'string',
      },
      workingfrom: {
        title: 'Vigente desde',
        type: 'string',


      },
      workinguntil: {
        title: 'Vigente hasta',
        type: 'string',
      },
    }
*/
    for (let index = 0; index < this.currentEntity.attributes.length; index++) {
      const element = this.currentEntity.attributes[index];
      this.settings.columns[element.id] = {title: element.name, type: 'string'}

    }
    this.elementAttributesArray = [];
    var currentElements = this.currentEntity.elements.filter( e => e.workingfrom != undefined).sort((a,b) => {
      return new Date(a.workingfrom).getTime() - new Date(b.workingfrom).getTime();
    });
    if(currentElements != undefined){
      for (let index = 0; index < currentElements.length; index++) {
        const element = currentElements[index].attributes;
        let elemento = new Object();
        elemento["id"] = currentElements[index].id;
        elemento["name"] = currentElements[index].name;
        //Calcular las dependencias por atributo

        if(currentElements[index].joins != undefined){
          elemento["dependency"] = currentElements[index].joins.map( j => {
            j.history = true;
            return j;
          });
        }

        elemento["disabledAt"] = currentElements[index].disabledAt;
        elemento["workingfrom"] = currentElements[index].workingfrom;
        elemento["workinguntil"] = currentElements[index].workinguntil;
        //si la entidad es geospacial
        if(this.currentEntity.geospatial == true){
          elemento["geometry"] = currentElements[index].geometry
        }

        /*
        for (const atributo in element) {
          //element[atributo];
          elemento[atributo] =  element[atributo];
        }
*/
        this.currentEntity.attributes.forEach(atr => {
          if(element.find(a => a.id == atr.id) != undefined){
            elemento[atr.id] = element.find(a => a.id == atr.id).value;
          }
        })

        this.elementAttributesArray.push(elemento)
      }
    }

    if(this.userRole.includes('superadmin')){
      this.settings.columns['dependency'] = {
        title: 'Relaciones',
        type:'custom',
        renderComponent: HistoricDpendenciesCellComponent,
        filter : false,
      };
    }
    //parametrizamos la smart table
    this.elementSource = new LocalDataSource();
    this.elementSource.load(this.elementAttributesArray.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));

    this.reset[0] = {};
  }

  public refresh(){
    this.ngOnInit();
  }
}
